'use client';

import { useState } from 'react';
import Container from '../ui/container';
import Title from '../ui/typography/title';
import { BrandsSlider } from '../ui/sliders';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
// import { BrandsBreakPoints } from '@/constants/swiperBreakPoints.constants';

const Brands = ({ data, isMobile, locale }) => {
  const [swiper, set_swiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  return (
    <Container className='py-0 sm:my-4 md:my-5 lg:my-8'>
      <Title
        slidesNo={swiper?.slides?.length}
        swiper={swiper}
        title={data?.[`title-${locale}`]}
        locale={locale}
        isBeginning={isBeginning}
        isEnd={isEnd}
        // hasMore
        // href={data?.value?.[0]?.url || '#'}
      />
      <div className='max-sm:!-mt-1.5 sm:mt-3 md:mt-2 lg:mt-5'>
        <Swiper
          onInit={(e) => set_swiper(e)}
          dir={locale === 'ar' ? 'rtl' : 'ltr'}
          slidesPerView='auto'
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          // breakpoints={BrandsBreakPoints}
          breakpoints={{
            320: { spaceBetween: 16 },
            1024: { spaceBetween: 50 },
          }}
          modules={[Autoplay]}
          autoplay={{ delay: 2500, pauseOnMouseEnter: true }}
        >
          {data?.value?.map((info, i) =>
            (isMobile ? info?.['mobile-active'] : info?.active) ? (
              <SwiperSlide
                key={i}
                className='max-w-40 min-w-40 max-lg:max-w-34 max-lg:min-w-34 max-md:max-w-30 max-md:min-w-30 max-sm:max-w-25 max-sm:min-w-25'
              >
                <BrandsSlider isMobile={isMobile} locale={locale} info={info} />
              </SwiperSlide>
            ) : null
          )}
        </Swiper>
      </div>
    </Container>
  );
};

export default Brands;
